module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/homepage-small.afac968c602b84a3118b9cbb7bb6a7d0.jpg";